module.exports = __webpack_public_path__ + "img/2.5bba79c0.png";